/**
 * Console breadcrumbs for Word-webview debugging on localhost/stage/dev.
 * Silent in unit tests and on the production add-in host.
 * Never log tokens, Authorization headers, filenames, or request bodies.
 */

import { isNonProductionHost } from "./runtime-env";

const PREFIX = "[AILA]";

function safeExtra(extra: Record<string, unknown> | undefined): Record<string, unknown> | "" {
  if (extra == null) return "";
  return extra;
}

export function canLog(): boolean {
  if (process.env.NODE_ENV === "test") return false;
  return isNonProductionHost();
}

export function debugLog(area: string, message: string, extra?: Record<string, unknown>): void {
  if (!canLog()) return;
  console.info(PREFIX, area, message, safeExtra(extra));
}

export function debugWarn(area: string, message: string, extra?: Record<string, unknown>): void {
  if (!canLog()) return;
  console.warn(PREFIX, area, message, safeExtra(extra));
}

export function debugError(area: string, message: string, extra?: Record<string, unknown>): void {
  if (!canLog()) return;
  console.error(PREFIX, area, message, safeExtra(extra));
}
